import BaseController from "niteroi/packages/system/controllers/Base.controller";
import {SharedServices} from "niteroi/services/SharedServices";
import UIComponent from "sap/ui/core/UIComponent";
import Avatar from "sap/m/Avatar";
import XMLView from "sap/ui/core/mvc/XMLView";
import Carousel from "sap/m/Carousel";
import HeroBanner from "sap/f/HeroBanner";
import GenericTile, {GenericTile$PressEvent} from "sap/m/GenericTile";
import VBox from "sap/m/VBox";
import Card from "sap/f/Card";
import TileContent from "sap/m/TileContent";

export default class Home extends BaseController {
    public heroBannerInterval: number = -1;
    private activeHomeValueTile: string = "simplicity";

    public onInit(): void {
        super.onInit();
        SharedServices.updateTheme(this.getOwnerComponent() as UIComponent);
        (this.byId("worksHeroBanner") as HeroBanner).addStyleClass("isLoaded");
        const carousel = this.byId("worksHeroBannerCarousel") as Carousel;
        carousel.attachPageChanged(() => {
            this.stopCarouselTimer();
            this.startCarouselTimer(carousel)
        });

        carousel.addEventDelegate({
            "onmouseover": () => this.stopCarouselTimer(),
            "onmouseout": () => this.startCarouselTimer(carousel)
        }, this);

        this.startCarouselTimer(carousel);
    }

    public onAfterRendering(): void {
    }

    public startCarouselTimer(carousel: Carousel): void {
        this.stopCarouselTimer();
        if (this.heroBannerInterval === -1) {
            const heroBannerTime = () => {
                carousel.next();
            };

            this.heroBannerInterval = window.setInterval(heroBannerTime, 5000);
        }
    }

    public stopCarouselTimer(): void{
        if (this.heroBannerInterval > -1) {
            window.clearInterval(this.heroBannerInterval);
            this.heroBannerInterval = -1;
        }
    }

    public onExit(): void {
        window.clearInterval(this.heroBannerInterval);
        super.onExit();
    }

    public onPressNavigateToContact(): void {
        this.navTo("contact", {}, true);
    }

    public onPressNavigateToPricing(): void {
        this.navTo("pricing", {}, true);
    }

    public onPressCardLogin(): void {
        const avatar = (((this.getOwnerComponent() as UIComponent)?.getRootControl() as XMLView)?.byId("worksShellBarAvatar") as Avatar);
        avatar.firePress();
    }

    public onPressNavigateToDemo(): void {
        this.navTo("demo", {}, true);
    }

    public onPressHomeBannerValueTiles(event: GenericTile$PressEvent): void {
        const tile = event.getSource();
        const verticalBox = tile.getParent() as VBox;
        (verticalBox.getItems() as Array<GenericTile>).forEach((genericTile: GenericTile) => {
            genericTile.setFrameType("TwoByHalf");
            (genericTile.getTileContent() as Array<TileContent>)[0].setVisible(false);
        });
        const newActiveTileId = tile.getId().split("-").pop();

        (verticalBox.getParent() as Card).removeStyleClass(this.activeHomeValueTile).addStyleClass(newActiveTileId);

        this.activeHomeValueTile = newActiveTileId;

        tile.setFrameType("TwoByOne");
        (tile.getTileContent() as Array<TileContent>)[0].setVisible(true);
    }
}
